import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { partnerNewsKeys } from '@/api/query-keys';
import {
  listPartnerNewsAdminContract,
  type ListPartnerNewsAdminResponse,
  type PartnerNewsAdmin
} from '@bliks-io/contracts';

/** Every partner news entry, drafts included (superadmin). */
export function useAdminPartnerNews() {
  return useQuery({
    queryKey: partnerNewsKeys.admin(),
    queryFn: async ({ signal }): Promise<PartnerNewsAdmin[]> => {
      const { data } = await apiClient.get<ListPartnerNewsAdminResponse>(
        listPartnerNewsAdminContract.path,
        { signal }
      );
      return data.data;
    }
  });
}
